.livePriceBox {
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  display: flex;
}

.priceContainer {
  display: flex;
  align-items: center;
}

.livePrice {
  font-family: var(--font-roboto-mono);
  padding-bottom: 0;
}

.priceChange {
  padding-left: 8px;
  font-family: var(--font-roboto-mono);
}

.divider {
  margin: 0;
}

.marketIndicatorStyled {
  margin-left: 10px;
  white-space: nowrap;
}

.default {
  color: var(--text-soft);
}

.negative {
  color: var(--viz-bearish);
}

.positive {
  color: var(--viz-bullish);
}
